import { GuaranteeTypeEnum } from '@insurance/api/requests'
import { useValidationsField } from '@insurance/hooks'
import { Col, Form, Input, Row } from 'antd'
import { useTranslation } from 'react-i18next'

import { AtaCarnetGoods } from './AtaCarnetGoods'
import { formProps } from './utils'

export const GuaranteeTypeFields = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()

  const {
    guaranteeTypeProps,
    tenderProps,
    tenderObjectProps,
    guaranteedContractProps,
    contractObjectProps,
    customsRegimeProps,
    customsReferenceProps
  } = formProps(t)

  const guaranteeType = Form.useWatch<GuaranteeTypeEnum>(
    guaranteeTypeProps.name,
    { preserve: true }
  )

  if (!guaranteeType) return null

  if (guaranteeType === GuaranteeTypeEnum.OFFER)
    return (
      <Row gutter={[12, 12]}>
        <Col xs={24} lg={12}>
          <Form.Item {...tenderProps} rules={[required]}>
            <Input placeholder={tenderProps.label} />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item {...tenderObjectProps} rules={[required]}>
            <Input placeholder={tenderObjectProps.label} />
          </Form.Item>
        </Col>
      </Row>
    )

  if (guaranteeType === GuaranteeTypeEnum.PERFORMANCE)
    return (
      <Row gutter={[12, 12]}>
        <Col xs={24} lg={12}>
          <Form.Item {...guaranteedContractProps} rules={[required]}>
            <Input placeholder={guaranteedContractProps.label} />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item {...contractObjectProps} rules={[required]}>
            <Input placeholder={contractObjectProps.label} />
          </Form.Item>
        </Col>
      </Row>
    )

  if (guaranteeType === GuaranteeTypeEnum.CUSTOMS)
    return (
      <Row gutter={[12, 12]}>
        <Col xs={24} lg={12}>
          <Form.Item {...customsRegimeProps} rules={[required]}>
            <Input placeholder={customsRegimeProps.label} />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item {...customsReferenceProps}>
            <Input placeholder={customsReferenceProps.label} />
          </Form.Item>
        </Col>
      </Row>
    )

  if (guaranteeType === GuaranteeTypeEnum.ATA_CARNET) return <AtaCarnetGoods />

  return null
}
